/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  MnemonicAggregateData,
  ValidationErrorResponse,
  WellAndTimePeriodInfoRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MnemonicAggregateDataFromJSON,
    MnemonicAggregateDataToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
    WellAndTimePeriodInfoRequestFromJSON,
    WellAndTimePeriodInfoRequestToJSON,
} from '../models/index';

export interface GetIntervalToolDataRequest {
    wellAndTimePeriodInfoRequest: WellAndTimePeriodInfoRequest;
}

/**
 * 
 */
export class MonitoringToolsApi extends runtime.BaseAPI {

    /**
     */
    async getIntervalToolDataRaw(requestParameters: GetIntervalToolDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MnemonicAggregateData>>> {
        if (requestParameters['wellAndTimePeriodInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'wellAndTimePeriodInfoRequest',
                'Required parameter "wellAndTimePeriodInfoRequest" was null or undefined when calling getIntervalToolData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/monitoring/tools/interval/data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WellAndTimePeriodInfoRequestToJSON(requestParameters['wellAndTimePeriodInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MnemonicAggregateDataFromJSON));
    }

    /**
     */
    async getIntervalToolData(requestParameters: GetIntervalToolDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MnemonicAggregateData>> {
        const response = await this.getIntervalToolDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
